let routes = [
  {
    path: '/',
    redirect: '/home',
    component: resolve => require(["page/home"], resolve),
    children: [{
      path: '/home',
      component: resolve => require(["page/home"], resolve),
    }]
  },
  {
    path: '/news',
    component: resolve => require(["page/news"], resolve),
  },
  {
    path: '/friend',
    component: resolve => require(["page/friend"], resolve),
  },
  {
    path: '/contactus',
    component: resolve => require(["page/contact"], resolve),
  },
  {
    path: '/joinus',
    component: resolve => require(["page/joinus"], resolve),
  },
  {
    path: '/about_adjuz',
    component: resolve => require(["page/aboutAdjuz"], resolve),
  },
  //  {
  //      path: '/interaction',
  //      component: resolve => require(["page/interaction"], resolve),
  //  },
  {
    path: '/aso',
    component: resolve => require(["page/aso"], resolve),
  },
  {
    path: '/resetpwd',
    component: resolve => require(["page/aso/setpwd"], resolve),
  },
  // MetaHands
  {
    path: '/metahands',
    component: resolve => require(["page/metahands"], resolve),
  },
]
export default new VueRouter({
  mode: 'history',
  routes
})


// WEBPACK FOOTER //
// ./src/base/router/index.js